import { clientePedido } from '../../apiClient/index'



function initialState () {
  return {    
    perfil: undefined
   }
}

const moduloPerfil = {
  namespaced: true,
  state: initialState,
  actions: {
    getPerfil(context) {
      // si el perfil está inicializado no lo vuelvo a buscar
      //if(context.state.perfil !== undefined)
        //return

      // obtengo el token con el cual obtendremos el perfil
      let tokenName = 'SistemaPedidoToken'
      let token = JSON.parse(localStorage.getItem(tokenName))
      let idPerfil = token.IdUsuario

      // busco el perfil
      let payload = { usu_id: idPerfil }

      clientePedido.get('api/Perfil/GetPerfil', { params: payload })
      .then(response => {
         context.commit('setPerfil', response.data)
      })
    },
    solicitarActualizacion(context, payload) {
      return new Promise((resolve) => {
        clientePedido.post('/api/Perfil/SolicitarActualizacion', payload)
        .then(response => { resolve(response.data) })
      })
      
    }
  },
  mutations: {
    setPerfil(state, payload)
    {
      state.perfil = payload
    },
  }
}

export default moduloPerfil